import { Outlet } from "react-router";
import { Footer } from "~/components/marketing/footer";
import { Navbar } from "~/components/marketing/navbar";

export default function MarketingLayout() {
	return (
		<div className="app-glass-canvas flex min-h-screen flex-col">
			<Navbar />
			<main className="flex-1">
				<Outlet />
			</main>
			<Footer />
		</div>
	);
}
